import { Box, Typography } from "@mui/material";
import Breadcrumbs from "components/common/Breadcrumbs";
import useWorkOrders from "hooks/workOrders/useWorkOrders";
import WorkOrderForm from "./WorkOrderForm";

export default function WorkOrderNew() {
  const { createWorkOrder } = useWorkOrders();

  return (
    <Box>
      <Breadcrumbs
        data={[
          { label: "Home", to: "/" },
          { label: "Work Orders", to: "/work_orders" },
          { label: "New Work Order" },
        ]}
      />
      <Typography variant="h5" fontWeight="bold" sx={{ mt: 2 }}>
        New Work Order
      </Typography>
      <WorkOrderForm
        initialValues={{}}
        onSubmit={async (values) => {
          await createWorkOrder(values);
        }}
      />
    </Box>
  );
}
